import React from 'react'
import { RouteComponentProps } from 'react-router-dom'

import gql from 'graphql-tag'
import { Table } from 'antd'
import { useTitle } from '@/utils/hooks'
import { useLlmChatQueueQuery, LlmChatQueueQuery } from './__gen'
import { ProcessButton } from './process-button'

// import style from './index.module.sass'

gql`
    query llmChatQueue {
  llmChatAdmin_List(afterProcessingCutoff: true, orderBy: [{field: lastMessage, direction: ASC}]) {
    objects {
      id
      created
		lastMessage
		minutesSinceProcessingCutoff
      processedAt
    }
  }
}
    `;

type Chat = NonNullable<LlmChatQueueQuery['llmChatAdmin_List']>['objects'][number]

const formatDatetime = (value: string | null) => {
	if (!value) return '—'
	const d = new Date(value)
	return d.toLocaleString(undefined, { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' })
}

const columns = [
	{
		title: 'ID',
		dataIndex: 'id',
		key: 'id',
	},
	{
		title: 'Created',
		dataIndex: 'created',
		key: 'created',
		render: (v: string) => formatDatetime(v),
	},
	{
		title: 'Processed At',
		dataIndex: 'processedAt',
		key: 'processedAt',
		render: (v: string | null, record: Chat) => (
		<><ProcessButton id={record.id} processedAt={v} /><br/>{v ? formatDatetime(v) : ''}</>),
	},
	{
		title: 'Last Message',
		dataIndex: 'lastMessage',
		key: 'lastMessage',
		render: (v: any) => formatDatetime(v),
	},
	{
		title: 'Minutes Since Processing Ready',
		dataIndex: 'minutesSinceProcessingCutoff',
		key: 'minutesSinceProcessingCutoff',
	},
]

export const LlmChatQueue = ({ match }: RouteComponentProps<{}>) => {
	useTitle("Super User - Queue")
	const { data, loading, error } = useLlmChatQueueQuery()
	const chats = data?.llmChatAdmin_List?.objects ?? []
	return (
		<>
			<h2>Unprocessed Llm Chats</h2>
			<Table<Chat>
				columns={columns}
				dataSource={chats}
				rowKey="id"
				loading={loading}
				pagination={false}
				size="small"
				locale={{ emptyText: 'No chats waiting to be processed' }}
			/>
			{error && <p>Error: {error.message}</p>}
		</>
	)
}
